export default function DeleteAccount() {
  return (
    <div className="container mt-5 mb-5">
      <h1>Delete Your Account</h1>

      <h2>How to delete your account</h2>
      <p>
        If you signed in to DevilRank with Apple, you can delete your account
        and all associated data directly in the app:
      </p>
      <ol>
        <li>Open the DevilRank app and go to the Profile tab.</li>
        <li>Tap <strong>Delete Account</strong>.</li>
        <li>Confirm the deletion when prompted.</li>
      </ol>
      <p>
        This immediately and permanently deletes your account. If you used
        the app without signing in (the default, anonymous mode), there is no
        account to delete - simply uninstalling the app removes it and its
        locally stored preferences from your device.
      </p>

      <h2>What gets deleted</h2>
      <p>Deleting your account permanently removes:</p>
      <ul>
        <li>Your Apple sign-in credential link to the app</li>
        <li>
          Your saved profile (display name, MOS, rank, and composite score)
        </li>
        <li>Your notification preferences and registered push tokens</li>
      </ul>

      <h2>What is kept</h2>
      <p>
        Publicly sourced USMC cutting score data is not personal data and is
        not affected by an account deletion. If you contacted support before
        deleting your account, that message may be retained briefly for
        support recordkeeping, consistent with our{" "}
        <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>Need help?</h2>
      <p>
        If you can't access the app to delete your account yourself, reach
        out via our <a href="/support">Support page</a> and we'll process the
        deletion for you.
      </p>
    </div>
  );
}
